<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="flex flex-row flex-nowrap md:gap-3 items-center justify-between">
  <div class="flex flex-wrap w-1/4 justify-start">
    <img
      [routerLink]="['/events/forums']"
      class="left-arrow clickable"
      src="../../../../assets/icons/left-arrow.svg"
      alt="forum"
    />
    <h1 *ngIf="!isEdit" class="headeradminui-text pl-2">Create Forum</h1>
    <h1 *ngIf="isEdit && viewMode" class="headeradminui-text pl-2">
      View Forum
    </h1>
    <h1 *ngIf="isEdit && !viewMode" class="headeradminui-text pl-2">
      Edit Forum
    </h1>
  </div>
</div>

<nz-spin [nzSpinning]="pageLoading">
  <nz-card>
    <!-- Action Buttons -->
    <div *ngIf="isEdit" nz-row nzJustify="end" class="mb-4">
      <div nz-col>
        <button
          *ngIf="viewMode"
          (click)="editForm()"
          nz-button
          nzType="primary"
        >
          <span nz-icon nzType="edit"></span>
          Edit Forum
        </button>
      </div>
    </div>

    <!-- Main Form -->
    <form [formGroup]="validateForm" nz-form>
      <!-- Title, Category, Duration Row -->
      <div nz-row nzGutter="16">
        <div nz-col nzSpan="16">
          <nz-form-item>
            <nz-form-label nzFor="forumName" nzRequired nzSpan="24">
              Forum Title
            </nz-form-label>
            <nz-form-control nzErrorTip="Please input Forum Title" nzSpan="24">
              <input
                formControlName="forumName"
                id="forumName"
                nz-input
                placeholder="Forum Title"
              />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="4">
          <nz-form-item>
            <nz-form-label nzRequired nzSpan="24"> Category </nz-form-label>
            <nz-form-control>
              <nz-select
                formControlName="selectedCategory"
                id="forumCategory"
                nzAllowClear
                nzPlaceHolder="Select a Category"
                nzShowSearch
              >
                <nz-option
                  *ngFor="let category of eventCategories"
                  [nzLabel]="category.label"
                  [nzValue]="category.value"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <!-- Description and Key Points Row -->
      <div class="mt-5" nz-row nzGutter="10">
        <div nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label nzFor="forumDescription" nzRequired nzSpan="24">
              Description
            </nz-form-label>
            <nz-form-control nzSpan="24">
              <textarea
                formControlName="forumDescription"
                id="forumDescription"
                nz-input
                placeholder="Forum Description"
                rows="10"
              ></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <!-- Date and Time Fields Row -->
      <div class="mt-5" nz-row nzGutter="16">
        <div nz-col>
          <nz-form-item>
            <nz-form-label nzFor="forumStartDate" nzRequired nzSpan="24">
              Forum Start Date
            </nz-form-label>
            <nz-form-control>
              <nz-date-picker
                [nzFormat]="dateTimeFormat"
                formControlName="forumStartDate"
                id="forumStartDate"
                nzShowTime
              ></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>

        <!-- Forever Toggle -->
        <div nz-col>
          <nz-form-item>
            <nz-form-label nzSpan="24">Forever</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-switch
                formControlName="forever"
                [nzDisabled]="viewMode"
                nzCheckedChildren="Forever"
                nzUnCheckedChildren="Set End Date"
              ></nz-switch>
            </nz-form-control>
          </nz-form-item>
        </div>

        <!-- End Date - Hidden when Forever is ON -->
        <div *ngIf="!validateForm.get('forever')?.value" nz-col>
          <nz-form-item>
            <nz-form-label nzFor="forumEndDate" nzRequired nzSpan="24">
              Forum End Date
            </nz-form-label>
            <nz-form-control>
              <nz-date-picker
                [nzFormat]="dateTimeFormat"
                [nzDisabledDate]="disableEndDate"
                formControlName="forumEndDate"
                id="forumEndDate"
                nzShowTime
              ></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col>
          <nz-form-item>
            <nz-form-label nzFor="visibleTime" nzRequired nzSpan="24">
              Visible From Start of Date
            </nz-form-label>
            <nz-form-control>
              <nz-date-picker
                [nzFormat]="dateFormat"
                formControlName="visibleTime"
                id="visibleTime"
              ></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col>
          <nz-form-item>
            <nz-form-label nzFor="cutOffTime" nzSpan="24">
              Registration Cut Off By the end of Selected Date
            </nz-form-label>
            <nz-form-control>
              <nz-date-picker
                [nzFormat]="dateFormat"
                formControlName="registrationCutOff"
                id="cutOffTime"
              ></nz-date-picker>
              <div
                nz-form-item-extra
                *ngIf="!validateForm.get('registrationCutOff')?.value"
                style="color: #999; font-size: 12px"
              >
                Empty means registration anytime
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="4">
          <nz-form-item>
            <nz-form-label nzSpan="24"> Max Registration Count </nz-form-label>

            <nz-form-control nzSpan="24">
              <input
                [(ngModel)]="maxRegistration"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="viewMode"
                nz-input
                type="number"
                min="0"
              />
              <small style="color: #999; font-size: 12px">
                0 or empty → Unlimited registrations
              </small>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <nz-divider></nz-divider>

      <!-- Languages and Payment Type -->
      <div class="mt-5" nz-row nzGutter="16">
        <div nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label nzFor="language"> Languages </nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-select
                formControlName="selectedLanguages"
                id="language"
                nzAllowClear
                nzMode="tags"
                nzPlaceHolder="Languages"
                nzShowSearch
              >
                <nz-option
                  *ngFor="let language of languages"
                  [nzLabel]="language"
                  [nzValue]="language"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label nzRequired>Forum Payment Types</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select formControlName="eventPaymentType" id="eventType">
                <nz-option
                  *ngFor="let type of eventPaymentTypes"
                  [nzLabel]="type"
                  [nzValue]="type"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <div class="mt-2">
            <ul>
              <li>
                <span nz-typography>
                  <strong>Free</strong>
                </span>
                - Free for all Customers
              </li>
              <li>
                <b>Paid</b>
                - Paid for all Customers
              </li>
              <li>
                <b>Retail Paid</b>
                - Free for Corporate users, Paid for retail users
              </li>
              <li>
                <b>Corporate Paid</b>
                - Free for Retail users, Paid for Corporate users
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Club Passes -->
      <div
        *ngIf="
          clubPasses!.length > 0 &&
          validateForm.get('eventPaymentType')?.value !== 'Free'
        "
        class="my-5"
        nz-row
        nzGutter="16"
      >
        <div nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label nzFor="clubPass">Club Passes</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-select
                formControlName="applicableClubPasses"
                id="clubPass"
                nzAllowClear
                nzMode="tags"
                nzPlaceHolder="Select a Club Pass"
                nzShowSearch
              >
                <nz-option
                  *ngFor="let clubPass of clubPasses"
                  [nzLabel]="clubPass.passName"
                  [nzValue]="clubPass"
                >
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>

    <!-- Corporate Only Event Switch -->
    <div nz-row class="mt-3">
      <div nz-col>
        <nz-switch
          [(ngModel)]="corporateOnlyEvent"
          [nzDisabled]="viewMode"
          nzCheckedChildren="Corporate Only"
          nzUnCheckedChildren="All Customers"
        ></nz-switch>
      </div>
    </div>

    <!-- Partner Selection -->
    <div *ngIf="corporateOnlyEvent" nz-row class="mt-2">
      <div nz-col nzSpan="12">
        <nz-select
          [(ngModel)]="selectedPartners"
          [nzDisabled]="viewMode"
          class="min-w-[400px]"
          nzShowSearch="true"
          nzMode="multiple"
          nzPlaceHolder="Please select partners"
        >
          <nz-option
            *ngFor="let partner of partners"
            [nzLabel]="partner.partner"
            [nzValue]="partner.id"
          ></nz-option>
        </nz-select>
      </div>
    </div>

    <!-- Thumbnail Image -->
    <nz-divider nzOrientation="left" nzText="Thumbnail Image"></nz-divider>
    <div nz-row nzGutter="16">
      <div nz-col nzSpan="12">
        <span>
          <b>
            Thumbnail Image (Single, ratio of image dimension should be 1:1)
          </b>
        </span>
        <br />
        <input
          [disabled]="viewMode"
          (change)="uploadThumbnailImage($event)"
          accept=".jpg,.jpeg,.png"
          type="file"
        />
        <div
          *ngIf="squareImagePreviewUrl || squareImageLink"
          nz-col
          nzSpan="12"
          style="width: 100px"
          class="pt-3"
        >
          <img
            [src]="squareImagePreviewUrl || squareImageLink"
            class="h-fit object-cover"
            alt="thumbnail"
          />
        </div>
      </div>
    </div>

    <!-- Banner Images -->
    <nz-divider nzOrientation="left" nzText="Banner Images"></nz-divider>
    <div nz-row>
      <div nz-col nzSpan="12">
        <span>
          <b>
            Banner Images (Multiple, ratio of image dimension should be 2:1)
          </b>
        </span>
        <br />
        <input
          [disabled]="viewMode"
          (change)="uploadImages($event)"
          multiple
          accept=".jpg,.jpeg,.png"
          type="file"
        />
        <div *ngFor="let image of selectedBannerFiles" class="mt-2">
          <p class="text-sm text-gray-600">{{ image.name }}</p>
        </div>
      </div>
    </div>
    <!-- Selected Banner Previews (replace on each choose) -->
    <div nz-row class="pt-3" *ngIf="bannerImagesPreviewUrls.length">
      <div
        nz-col
        *ngFor="let preview of bannerImagesPreviewUrls; let i = index"
        style="width: 200px"
        class="pr-3 pb-3"
      >
        <img [src]="preview" class="h-fit object-cover" alt="banner preview" />
        <div class="pt-2">
          <button
            *ngIf="!viewMode"
            (click)="deleteBannerPreview(i)"
            nz-button
            nzDanger
            nzSize="small"
          >
            <span nz-icon nzType="delete"></span>
            Delete
          </button>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap justify-start items-center pr-4 pb-5">
      <div *ngFor="let data of imagesLinks; index as i" class="pt-5 pr-3">
        <nz-card style="width: 200px">
          <img [src]="data" class="h-fit object-cover" alt="banner" />
        </nz-card>
        <div class="pt-2">
          <button
            *ngIf="!viewMode"
            (click)="deleteImage(i)"
            nz-button
            nzDanger
            nzSize="small"
          >
            <span nz-icon nzType="delete"></span>
            Delete
          </button>
        </div>
      </div>
    </div>

    <!-- Share Details -->
    <nz-divider nzOrientation="left" nzText="Share Details"></nz-divider>
    <div nz-row nzGutter="16">
      <div nz-col nzSpan="10">
        <nz-form-label nzRequired nzSpan="24"> Share Message </nz-form-label>
        <textarea
          [disabled]="viewMode"
          [(ngModel)]="shareMessage"
          nz-input
          rows="4"
          placeholder="Enter share message"
        ></textarea>
      </div>

      <div nz-col nzSpan="6">
        <span>
          <b>
            Upload Share Image (Single, ratio of image dimension should be 2:1)
          </b>
        </span>
        <br />
        <input
          [disabled]="viewMode"
          (change)="uploadShareImage($event)"
          accept=".jpg,.jpeg,.png"
          type="file"
        />
        <div
          *ngIf="shareImagePreviewUrl || shareImageLink"
          nz-col
          nzSpan="12"
          style="width: 300px"
          class="pt-3"
        >
          <img
            [src]="shareImagePreviewUrl || shareImageLink"
            class="h-fit object-cover"
            alt="shareImage"
          />
        </div>
      </div>
    </div>

    <!-- Entry Fee Details -->
    <nz-divider
      *ngIf="eventEntryFee.length"
      nzOrientation="left"
      nzText="Entry Fee Details"
    ></nz-divider>
    <div
      *ngIf="
        !viewMode && validateForm.get('eventPaymentType')?.value !== 'Free'
      "
    >
      <div nz-row nzJustify="end" class="mb-3">
        <button (click)="addEntryFee()" nz-button nzType="dashed">
          <span nz-icon nzType="plus"></span>
          Add Entry Fee
        </button>
      </div>
    </div>

    <div>
      <div
        *ngFor="let fee of eventEntryFee; index as i"
        nz-row
        nzGutter="16"
        class="mb-3"
      >
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzRequired nzSpan="24"> Amount </nz-form-label>
            <nz-form-control>
              <nz-input-group nzPrefix="₹" nzSuffix="INR">
                <input
                  [(ngModel)]="fee.amount"
                  [disabled]="viewMode"
                  nz-input
                  placeholder="Amount"
                  type="number"
                />
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzRequired nzSpan="24"> MarkUp </nz-form-label>
            <nz-form-control>
              <nz-input-group nzPrefix="₹" nzSuffix="INR">
                <input
                  [(ngModel)]="fee.markupPrice"
                  [disabled]="viewMode"
                  nz-input
                  placeholder="Markup Price"
                  type="number"
                />
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div
          *ngIf="!viewMode && eventEntryFee.length > 1"
          nz-col
          nzSpan="4"
          class="flex items-end pb-3"
        >
          <button (click)="eventEntryFee.splice(i, 1)" nz-button nzDanger>
            <span nz-icon nzType="delete"></span>
          </button>
        </div>
      </div>
    </div>

    <nz-divider nzOrientation="left" nzText="Presenter Details"></nz-divider>

    <div
      *ngFor="let row of presenterRows; let i = index"
      nz-row
      nzGutter="16"
      style="margin-bottom: 20px; align-items: center"
    >
      <!-- Presenter Select -->
      <div nz-col nzSpan="8">
        <nz-select
          [disabled]="viewMode"
          [(ngModel)]="row.presenterId"
          nzPlaceHolder="Select Presenter"
          nzShowSearch
          nzAllowClear
          (ngModelChange)="onPresenterChange(i)"
          style="width: 100%"
        >
          <nz-option
            *ngFor="let expert of filteredExperts(i)"
            [nzLabel]="expert.expertId"
            [nzValue]="expert.name"
          ></nz-option>
        </nz-select>
      </div>

      <!-- Pay Toggle -->
      <div nz-col nzSpan="4" *ngIf="row.presenterId">
        <label style="margin-right: 8px">Pay?</label>
        <nz-switch [(ngModel)]="row.isPaid" [disabled]="viewMode"></nz-switch>
      </div>

      <!-- Amount -->
      <div nzSpan="6" *ngIf="row.isPaid" nz-row>
        <input
          nz-input
          type="number"
          [(ngModel)]="row.amount"
          placeholder="Amount"
          [disabled]="viewMode"
        />
        <span> INR (₹)</span>
      </div>

      <!-- Remove Button (except first row) -->
      <div nz-col nzSpan="2" *ngIf="i > 0">
        <button
          nz-button
          nzType="default"
          nzDanger
          (click)="removeRow(i)"
          [disabled]="viewMode"
        >
          X
        </button>
      </div>
    </div>

    <!-- ADD MORE BUTTON -->
    <button
      nz-button
      nzType="default"
      (click)="addPresenterRow()"
      style="margin-top: 15px"
      [disabled]="viewMode"
    >
      + Add More Presenter
    </button>

    <!-- Forum Settings -->
    <nz-divider nzOrientation="left" nzText="Forum Settings"></nz-divider>
    <div nz-row nzGutter="16">
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label>Discussion Available</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-switch
              [disabled]="viewMode"
              [(ngModel)]="isDiscussionAvailable"
              (ngModelChange)="onDiscussionAvailableChange()"
              nzCheckedChildren="Enabled"
              nzUnCheckedChildren="Disabled"
            ></nz-switch>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label>Users Can Post</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-switch
              [disabled]="viewMode || !isDiscussionAvailable"
              [(ngModel)]="canUserPost"
              nzCheckedChildren="Yes"
              nzUnCheckedChildren="No"
            ></nz-switch>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label>Experts Can Post</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-switch
              [disabled]="viewMode || !isDiscussionAvailable"
              [(ngModel)]="canExpertPost"
              nzCheckedChildren="Yes"
              nzUnCheckedChildren="No"
            ></nz-switch>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <nz-divider></nz-divider>

    <div nz-row *ngIf="!isEdit">
      <div nz-col>
        <label [(ngModel)]="testEvent" nz-checkbox> Test Forum </label>
      </div>
      <div nz-col>
        <label [(ngModel)]="testRealPayment" nz-checkbox>
          Test Real Payment
        </label>
      </div>
    </div>
    <!-- Action Buttons -->
    <nz-divider></nz-divider>
    <div *ngIf="!viewMode" nz-row nzJustify="space-between">
      <div nz-col>
        <button [routerLink]="['events/forums']" nz-button nzType="default">
          <span nz-icon nzType="arrow-left"></span>
          Cancel
        </button>
      </div>
      <div nz-col>
        <button
          (click)="addOrUpdateForum()"
          nz-button
          nzType="primary"
          [nzLoading]="loading"
        >
          <span nz-icon [nzType]="isEdit ? 'save' : 'plus'"></span>
          {{ isEdit ? "Update Forum" : "Create Forum" }}
        </button>
      </div>
    </div>
  </nz-card>
</nz-spin>
